// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `AggregateSpec`.
export const AggregateSpec = __t.enum("AggregateSpec", {
  Sum: __t.unit(),
  Avg: __t.unit(),
  Min: __t.unit(),
  Max: __t.unit(),
  Count: __t.unit(),
  get Rate() {
    return RateUnit;
  },
  Delta: __t.unit(),
  StdDev: __t.unit(),
  get DutyCycle() {
    return DutyPredicate;
  },
  get Derive() {
    return DeriveSpec;
  },
});
export type AggregateSpec = __Infer<typeof AggregateSpec>;

// The tagged union or sum type for the algebraic type `AggregateSpecV2`.
export const AggregateSpecV2 = __t.enum("AggregateSpecV2", {
  None: __t.unit(),
  StdDev: __t.unit(),
  get DutyCycle() {
    return DutyPredicate;
  },
});
export type AggregateSpecV2 = __Infer<typeof AggregateSpecV2>;

// The tagged union or sum type for the algebraic type `AlertCondition`.
export const AlertCondition = __t.enum("AlertCondition", {
  ThresholdExceeds: __t.f64(),
  ThresholdBelow: __t.f64(),
  NoDataFor: __t.u64(),
  ValueEquals: __t.string(),
  StuckValue: __t.u64(),
  get OutsideRange() {
    return AlertRange;
  },
});
export type AlertCondition = __Infer<typeof AlertCondition>;

// The tagged union or sum type for the algebraic type `AlertConditionV2`.
export const AlertConditionV2 = __t.enum("AlertConditionV2", {
  None: __t.unit(),
  StuckValue: __t.u64(),
  get OutsideRange() {
    return AlertRange;
  },
});
export type AlertConditionV2 = __Infer<typeof AlertConditionV2>;

// The tagged union or sum type for the algebraic type `AlertDeliveryKind`.
export const AlertDeliveryKind = __t.enum("AlertDeliveryKind", {
  Notification: __t.unit(),
  Webhook: __t.unit(),
  Email: __t.unit(),
});
export type AlertDeliveryKind = __Infer<typeof AlertDeliveryKind>;

export const AlertDeliveryTarget = __t.object("AlertDeliveryTarget", {
  id: __t.u64(),
  ruleId: __t.u64(),
  get kind() {
    return AlertDeliveryKind;
  },
  destination: __t.string(),
  enabled: __t.bool(),
});
export type AlertDeliveryTarget = __Infer<typeof AlertDeliveryTarget>;

export const AlertEvalSchedule = __t.object("AlertEvalSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type AlertEvalSchedule = __Infer<typeof AlertEvalSchedule>;

export const AlertEvent = __t.object("AlertEvent", {
  id: __t.u64(),
  ruleId: __t.u64(),
  projectId: __t.u32(),
  firedAt: __t.timestamp(),
  value: __t.string(),
  resolvedAt: __t.option(__t.timestamp()),
  acknowledgedAt: __t.option(__t.timestamp()),
});
export type AlertEvent = __Infer<typeof AlertEvent>;

export const AlertHistoryGcSchedule = __t.object("AlertHistoryGcSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type AlertHistoryGcSchedule = __Infer<typeof AlertHistoryGcSchedule>;

export const AlertRange = __t.object("AlertRange", {
  min: __t.f64(),
  max: __t.f64(),
});
export type AlertRange = __Infer<typeof AlertRange>;

export const AlertRule = __t.object("AlertRule", {
  id: __t.u64(),
  projectId: __t.u32(),
  twinId: __t.option(__t.string()),
  streamName: __t.string(),
  get streamType() {
    return TelemetryStreamType;
  },
  get condition() {
    return AlertCondition;
  },
  get severity() {
    return AlertSeverity;
  },
  name: __t.string(),
  description: __t.string(),
  enabled: __t.bool(),
  get lastState() {
    return AlertState;
  },
  lastEvaluatedAt: __t.option(__t.timestamp()),
  lastFiredAt: __t.option(__t.timestamp()),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  lastValueRepr: __t.option(__t.string()),
  lastChangeAt: __t.option(__t.timestamp()),
  get conditionV2() {
    return __t.option(AlertConditionV2);
  },
});
export type AlertRule = __Infer<typeof AlertRule>;

// The tagged union or sum type for the algebraic type `AlertSeverity`.
export const AlertSeverity = __t.enum("AlertSeverity", {
  Info: __t.unit(),
  Warning: __t.unit(),
  Critical: __t.unit(),
});
export type AlertSeverity = __Infer<typeof AlertSeverity>;

// The tagged union or sum type for the algebraic type `AlertState`.
export const AlertState = __t.enum("AlertState", {
  Clear: __t.unit(),
  Firing: __t.unit(),
});
export type AlertState = __Infer<typeof AlertState>;

export const AlertTargetListEvent = __t.object("AlertTargetListEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  success: __t.bool(),
  payload: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type AlertTargetListEvent = __Infer<typeof AlertTargetListEvent>;

export const AlertWebhookOutbox = __t.object("AlertWebhookOutbox", {
  id: __t.u64(),
  targetId: __t.u64(),
  ruleId: __t.u64(),
  eventId: __t.u64(),
  destination: __t.string(),
  payload: __t.string(),
  enqueuedAt: __t.timestamp(),
  attempts: __t.u32(),
  lastAttemptAt: __t.option(__t.timestamp()),
  lastError: __t.option(__t.string()),
});
export type AlertWebhookOutbox = __Infer<typeof AlertWebhookOutbox>;

export const AlertWebhookSchedule = __t.object("AlertWebhookSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type AlertWebhookSchedule = __Infer<typeof AlertWebhookSchedule>;

// The tagged union or sum type for the algebraic type `ArrayValue`.
export const ArrayValue = __t.enum("ArrayValue", {
  Boolean: __t.array(__t.bool()),
  Byte: __t.array(__t.i8()),
  get Bytes() {
    return __t.array(BytesWrapper);
  },
  Date: __t.array(__t.timestamp()),
  DateTime: __t.array(__t.timestamp()),
  Decimal: __t.array(__t.string()),
  Double: __t.array(__t.f64()),
  Duration: __t.array(__t.timeDuration()),
  Float: __t.array(__t.f32()),
  Integer: __t.array(__t.i32()),
  Long: __t.array(__t.i64()),
  Short: __t.array(__t.i16()),
  String: __t.array(__t.string()),
  Time: __t.array(__t.timestamp()),
  UnsignedByte: __t.byteArray(),
  UnsignedInteger: __t.array(__t.u32()),
  UnsignedLong: __t.array(__t.u64()),
  UnsignedShort: __t.array(__t.u16()),
  Uuid: __t.array(__t.string()),
});
export type ArrayValue = __Infer<typeof ArrayValue>;

export const BoolUpdate = __t.object("BoolUpdate", {
  streamName: __t.string(),
  value: __t.bool(),
});
export type BoolUpdate = __Infer<typeof BoolUpdate>;

// The tagged union or sum type for the algebraic type `BucketState`.
export const BucketState = __t.enum("BucketState", {
  Open: __t.unit(),
  Finalized: __t.unit(),
  Dirty: __t.unit(),
});
export type BucketState = __Infer<typeof BucketState>;

export const ByteUpdate = __t.object("ByteUpdate", {
  streamName: __t.string(),
  value: __t.i8(),
});
export type ByteUpdate = __Infer<typeof ByteUpdate>;

export const BytesWrapper = __t.object("BytesWrapper", {
  data: __t.byteArray(),
});
export type BytesWrapper = __Infer<typeof BytesWrapper>;

export const ChannelBucket = __t.object("ChannelBucket", {
  id: __t.u64(),
  channelId: __t.u64(),
  bucketStart: __t.timestamp(),
  count: __t.u64(),
  numericCount: __t.u64(),
  sum: __t.f64(),
  min: __t.f64(),
  max: __t.f64(),
  firstValue: __t.f64(),
  firstEventTime: __t.timestamp(),
  lastValue: __t.f64(),
  lastEventTime: __t.timestamp(),
  get state() {
    return BucketState;
  },
  sumSquares: __t.f64(),
  predicateMatchCount: __t.u64(),
});
export type ChannelBucket = __Infer<typeof ChannelBucket>;

export const ChannelTickSchedule = __t.object("ChannelTickSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type ChannelTickSchedule = __Infer<typeof ChannelTickSchedule>;

export const ComplexTelemetry = __t.object("ComplexTelemetry", {
  streamId: __t.u64(),
  streamName: __t.string(),
  get value() {
    return ComplexValue;
  },
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type ComplexTelemetry = __Infer<typeof ComplexTelemetry>;

// The tagged union or sum type for the algebraic type `ComplexValue`.
export const ComplexValue = __t.enum("ComplexValue", {
  get Array() {
    return ArrayValue;
  },
  get Enum() {
    return EnumValue;
  },
  get Map() {
    return MapValue;
  },
  get Object() {
    return ObjectValue;
  },
  get Geospatial() {
    return GeospatialValue;
  },
  get ScaledDecimal() {
    return ScaledDecimalValue;
  },
});
export type ComplexValue = __Infer<typeof ComplexValue>;

export const ComputedChannel = __t.object("ComputedChannel", {
  id: __t.u64(),
  projectId: __t.u32(),
  name: __t.string(),
  description: __t.string(),
  inputStreamName: __t.string(),
  get inputStreamType() {
    return TelemetryStreamType;
  },
  get aggregate() {
    return AggregateSpec;
  },
  get window() {
    return WindowSize;
  },
  anchorOffsetMinutes: __t.i32(),
  outputStreamName: __t.string(),
  enabled: __t.bool(),
  lastFinalizedBucket: __t.option(__t.timestamp()),
  droppedLateSamples: __t.u64(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  get sequenceOp() {
    return __t.option(SequenceOpSpec);
  },
  seqStateA: __t.f64(),
  seqStateB: __t.f64(),
  seqInitialized: __t.bool(),
  seqLastOutput: __t.f64(),
  seqSkippedCorrections: __t.u64(),
  get aggregateV2() {
    return __t.option(AggregateSpecV2);
  },
});
export type ComputedChannel = __Infer<typeof ComputedChannel>;

export const CusumParams = __t.object("CusumParams", {
  k: __t.f64(),
  h: __t.f64(),
});
export type CusumParams = __Infer<typeof CusumParams>;

export const DecimalUpdate = __t.object("DecimalUpdate", {
  streamName: __t.string(),
  value: __t.string(),
});
export type DecimalUpdate = __Infer<typeof DecimalUpdate>;

// The tagged union or sum type for the algebraic type `DeriveFn`.
export const DeriveFn = __t.enum("DeriveFn", {
  Add: __t.unit(),
  Sub: __t.unit(),
  Mul: __t.unit(),
  Div: __t.unit(),
  WeightedSum: __t.unit(),
});
export type DeriveFn = __Infer<typeof DeriveFn>;

export const DeriveSpec = __t.object("DeriveSpec", {
  get func() {
    return DeriveFn;
  },
  params: __t.array(__t.f64()),
});
export type DeriveSpec = __Infer<typeof DeriveSpec>;

export const DoubleUpdate = __t.object("DoubleUpdate", {
  streamName: __t.string(),
  value: __t.f64(),
});
export type DoubleUpdate = __Infer<typeof DoubleUpdate>;

// The tagged union or sum type for the algebraic type `DutyPredicate`.
export const DutyPredicate = __t.enum("DutyPredicate", {
  GreaterThan: __t.f64(),
  LessThan: __t.f64(),
});
export type DutyPredicate = __Infer<typeof DutyPredicate>;

export const EnumIntegerValue = __t.object("EnumIntegerValue", {
  name: __t.string(),
  value: __t.i32(),
});
export type EnumIntegerValue = __Infer<typeof EnumIntegerValue>;

export const EnumStringValue = __t.object("EnumStringValue", {
  name: __t.string(),
  value: __t.string(),
});
export type EnumStringValue = __Infer<typeof EnumStringValue>;

// The tagged union or sum type for the algebraic type `EnumValue`.
export const EnumValue = __t.enum("EnumValue", {
  get String() {
    return EnumStringValue;
  },
  get Integer() {
    return EnumIntegerValue;
  },
});
export type EnumValue = __Infer<typeof EnumValue>;

// The tagged union or sum type for the algebraic type `ExportKind`.
export const ExportKind = __t.enum("ExportKind", {
  TelemetryByStreamId: __t.unit(),
  TelemetryByStreamName: __t.unit(),
  AllTelemetry: __t.unit(),
  TelemetryStreams: __t.unit(),
});
export type ExportKind = __Infer<typeof ExportKind>;

export const ExportResultEvent = __t.object("ExportResultEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  get kind() {
    return ExportKind;
  },
  success: __t.bool(),
  payload: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type ExportResultEvent = __Infer<typeof ExportResultEvent>;

export const FloatUpdate = __t.object("FloatUpdate", {
  streamName: __t.string(),
  value: __t.f32(),
});
export type FloatUpdate = __Infer<typeof FloatUpdate>;

export const GeoCoordinates = __t.object("GeoCoordinates", {
  get positions() {
    return __t.array(GeoPosition);
  },
});
export type GeoCoordinates = __Infer<typeof GeoCoordinates>;

export const GeoLineString = __t.object("GeoLineString", {
  get coordinates() {
    return __t.array(GeoPosition);
  },
});
export type GeoLineString = __Infer<typeof GeoLineString>;

export const GeoMultiLineString = __t.object("GeoMultiLineString", {
  get lineStrings() {
    return __t.array(GeoCoordinates);
  },
});
export type GeoMultiLineString = __Infer<typeof GeoMultiLineString>;

export const GeoMultiPoint = __t.object("GeoMultiPoint", {
  get coordinates() {
    return __t.array(GeoPosition);
  },
});
export type GeoMultiPoint = __Infer<typeof GeoMultiPoint>;

export const GeoMultiPolygon = __t.object("GeoMultiPolygon", {
  get polygons() {
    return __t.array(GeoPolygon);
  },
});
export type GeoMultiPolygon = __Infer<typeof GeoMultiPolygon>;

export const GeoPoint = __t.object("GeoPoint", {
  get coordinates() {
    return GeoPosition;
  },
});
export type GeoPoint = __Infer<typeof GeoPoint>;

export const GeoPolygon = __t.object("GeoPolygon", {
  get rings() {
    return __t.array(GeoCoordinates);
  },
});
export type GeoPolygon = __Infer<typeof GeoPolygon>;

export const GeoPosition = __t.object("GeoPosition", {
  longitude: __t.f64(),
  latitude: __t.f64(),
  altitude: __t.option(__t.f64()),
});
export type GeoPosition = __Infer<typeof GeoPosition>;

// The tagged union or sum type for the algebraic type `GeospatialValue`.
export const GeospatialValue = __t.enum("GeospatialValue", {
  get Point() {
    return GeoPoint;
  },
  get MultiPoint() {
    return GeoMultiPoint;
  },
  get LineString() {
    return GeoLineString;
  },
  get MultiLineString() {
    return GeoMultiLineString;
  },
  get Polygon() {
    return GeoPolygon;
  },
  get MultiPolygon() {
    return GeoMultiPolygon;
  },
});
export type GeospatialValue = __Infer<typeof GeospatialValue>;

// The tagged union or sum type for the algebraic type `HttpMethod`.
export const HttpMethod = __t.enum("HttpMethod", {
  Get: __t.unit(),
  Post: __t.unit(),
  Put: __t.unit(),
  Patch: __t.unit(),
  Delete: __t.unit(),
});
export type HttpMethod = __Infer<typeof HttpMethod>;

// The tagged union or sum type for the algebraic type `ImportModeConflict`.
export const ImportModeConflict = __t.enum("ImportModeConflict", {
  SkipExisting: __t.unit(),
  UpdateExisting: __t.unit(),
  FailOnConflict: __t.unit(),
});
export type ImportModeConflict = __Infer<typeof ImportModeConflict>;

export const IntegerUpdate = __t.object("IntegerUpdate", {
  streamName: __t.string(),
  value: __t.i32(),
});
export type IntegerUpdate = __Infer<typeof IntegerUpdate>;

export const LocationUpdate = __t.object("LocationUpdate", {
  streamName: __t.string(),
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
});
export type LocationUpdate = __Infer<typeof LocationUpdate>;

export const LongUpdate = __t.object("LongUpdate", {
  streamName: __t.string(),
  value: __t.i64(),
});
export type LongUpdate = __Infer<typeof LongUpdate>;

// The tagged union or sum type for the algebraic type `MapValue`.
export const MapValue = __t.enum("MapValue", {
  get Boolean() {
    return __t.array(StringBooleanPair);
  },
  get Byte() {
    return __t.array(StringBytePair);
  },
  get Bytes() {
    return __t.array(StringBytesPair);
  },
  get Date() {
    return __t.array(StringDatePair);
  },
  get DateTime() {
    return __t.array(StringDateTimePair);
  },
  get Decimal() {
    return __t.array(StringDecimalPair);
  },
  get Double() {
    return __t.array(StringDoublePair);
  },
  get Duration() {
    return __t.array(StringDurationPair);
  },
  get Float() {
    return __t.array(StringFloatPair);
  },
  get Integer() {
    return __t.array(StringIntegerPair);
  },
  get Long() {
    return __t.array(StringLongPair);
  },
  get Short() {
    return __t.array(StringShortPair);
  },
  get String() {
    return __t.array(StringStringPair);
  },
  get Time() {
    return __t.array(StringTimePair);
  },
  get UnsignedByte() {
    return __t.array(StringUnsignedBytePair);
  },
  get UnsignedInteger() {
    return __t.array(StringUnsignedIntegerPair);
  },
  get UnsignedLong() {
    return __t.array(StringUnsignedLongPair);
  },
  get UnsignedShort() {
    return __t.array(StringUnsignedShortPair);
  },
  get Uuid() {
    return __t.array(StringUuidPair);
  },
});
export type MapValue = __Infer<typeof MapValue>;

// The tagged union or sum type for the algebraic type `ModuleRole`.
export const ModuleRole = __t.enum("ModuleRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type ModuleRole = __Infer<typeof ModuleRole>;

export const ModuleServiceConfig = __t.object("ModuleServiceConfig", {
  id: __t.u32(),
  adminIdentity: __t.identity(),
});
export type ModuleServiceConfig = __Infer<typeof ModuleServiceConfig>;

export const ModuleUser = __t.object("ModuleUser", {
  identity: __t.identity(),
  get role() {
    return ModuleRole;
  },
});
export type ModuleUser = __Infer<typeof ModuleUser>;

export const ObjectField = __t.object("ObjectField", {
  name: __t.string(),
  get value() {
    return PrimitiveValue;
  },
});
export type ObjectField = __Infer<typeof ObjectField>;

export const ObjectValue = __t.object("ObjectValue", {
  get fields() {
    return __t.array(ObjectField);
  },
});
export type ObjectValue = __Infer<typeof ObjectValue>;

// The tagged union or sum type for the algebraic type `PollingStatus`.
export const PollingStatus = __t.enum("PollingStatus", {
  Running: __t.unit(),
  Paused: __t.unit(),
  Stopped: __t.unit(),
  Error: __t.unit(),
});
export type PollingStatus = __Infer<typeof PollingStatus>;

export const PostRestoreMarker = __t.object("PostRestoreMarker", {
  id: __t.u32(),
  ranAtMicros: __t.i64(),
});
export type PostRestoreMarker = __Infer<typeof PostRestoreMarker>;

export const PrimitiveTelemetryBool = __t.object("PrimitiveTelemetryBool", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.bool(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryBool = __Infer<typeof PrimitiveTelemetryBool>;

export const PrimitiveTelemetryByte = __t.object("PrimitiveTelemetryByte", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.i8(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryByte = __Infer<typeof PrimitiveTelemetryByte>;

export const PrimitiveTelemetryBytes = __t.object("PrimitiveTelemetryBytes", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.byteArray(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryBytes = __Infer<typeof PrimitiveTelemetryBytes>;

export const PrimitiveTelemetryDate = __t.object("PrimitiveTelemetryDate", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.timestamp(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryDate = __Infer<typeof PrimitiveTelemetryDate>;

export const PrimitiveTelemetryDateTime = __t.object("PrimitiveTelemetryDateTime", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.timestamp(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryDateTime = __Infer<typeof PrimitiveTelemetryDateTime>;

export const PrimitiveTelemetryDecimal = __t.object("PrimitiveTelemetryDecimal", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.string(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryDecimal = __Infer<typeof PrimitiveTelemetryDecimal>;

export const PrimitiveTelemetryDouble = __t.object("PrimitiveTelemetryDouble", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.f64(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryDouble = __Infer<typeof PrimitiveTelemetryDouble>;

export const PrimitiveTelemetryDuration = __t.object("PrimitiveTelemetryDuration", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.timeDuration(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryDuration = __Infer<typeof PrimitiveTelemetryDuration>;

export const PrimitiveTelemetryFloat = __t.object("PrimitiveTelemetryFloat", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.f32(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryFloat = __Infer<typeof PrimitiveTelemetryFloat>;

export const PrimitiveTelemetryInteger = __t.object("PrimitiveTelemetryInteger", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.i32(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryInteger = __Infer<typeof PrimitiveTelemetryInteger>;

export const PrimitiveTelemetryLong = __t.object("PrimitiveTelemetryLong", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.i64(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryLong = __Infer<typeof PrimitiveTelemetryLong>;

export const PrimitiveTelemetryShort = __t.object("PrimitiveTelemetryShort", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.i16(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryShort = __Infer<typeof PrimitiveTelemetryShort>;

export const PrimitiveTelemetryString = __t.object("PrimitiveTelemetryString", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.string(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryString = __Infer<typeof PrimitiveTelemetryString>;

export const PrimitiveTelemetryTime = __t.object("PrimitiveTelemetryTime", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.timestamp(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryTime = __Infer<typeof PrimitiveTelemetryTime>;

export const PrimitiveTelemetryUnsignedByte = __t.object("PrimitiveTelemetryUnsignedByte", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.u8(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryUnsignedByte = __Infer<typeof PrimitiveTelemetryUnsignedByte>;

export const PrimitiveTelemetryUnsignedInteger = __t.object("PrimitiveTelemetryUnsignedInteger", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.u32(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryUnsignedInteger = __Infer<typeof PrimitiveTelemetryUnsignedInteger>;

export const PrimitiveTelemetryUnsignedLong = __t.object("PrimitiveTelemetryUnsignedLong", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.u64(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryUnsignedLong = __Infer<typeof PrimitiveTelemetryUnsignedLong>;

export const PrimitiveTelemetryUnsignedShort = __t.object("PrimitiveTelemetryUnsignedShort", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.u16(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryUnsignedShort = __Infer<typeof PrimitiveTelemetryUnsignedShort>;

export const PrimitiveTelemetryUuid = __t.object("PrimitiveTelemetryUuid", {
  streamId: __t.u64(),
  streamName: __t.string(),
  value: __t.string(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type PrimitiveTelemetryUuid = __Infer<typeof PrimitiveTelemetryUuid>;

// The tagged union or sum type for the algebraic type `PrimitiveValue`.
export const PrimitiveValue = __t.enum("PrimitiveValue", {
  Boolean: __t.bool(),
  Byte: __t.i8(),
  Bytes: __t.byteArray(),
  Date: __t.timestamp(),
  DateTime: __t.timestamp(),
  Decimal: __t.string(),
  Double: __t.f64(),
  Duration: __t.timeDuration(),
  Float: __t.f32(),
  Integer: __t.i32(),
  Long: __t.i64(),
  Short: __t.i16(),
  String: __t.string(),
  Time: __t.timestamp(),
  UnsignedByte: __t.u8(),
  UnsignedInteger: __t.u32(),
  UnsignedLong: __t.u64(),
  UnsignedShort: __t.u16(),
  Uuid: __t.string(),
});
export type PrimitiveValue = __Infer<typeof PrimitiveValue>;

export const ProjectAlertNotification = __t.object("ProjectAlertNotification", {
  id: __t.u64(),
  projectId: __t.u32(),
  eventId: __t.u64(),
  ruleId: __t.u64(),
  get severity() {
    return AlertSeverity;
  },
  title: __t.string(),
  message: __t.string(),
  createdAt: __t.timestamp(),
});
export type ProjectAlertNotification = __Infer<typeof ProjectAlertNotification>;

export const ProjectScopeConfig = __t.object("ProjectScopeConfig", {
  id: __t.u32(),
  projectName: __t.string(),
  configuredAt: __t.timestamp(),
  allowedScopes: __t.option(__t.array(__t.string())),
});
export type ProjectScopeConfig = __Infer<typeof ProjectScopeConfig>;

export const ProjectTenantConfig = __t.object("ProjectTenantConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  isPublic: __t.bool(),
  configuredAt: __t.timestamp(),
});
export type ProjectTenantConfig = __Infer<typeof ProjectTenantConfig>;

// The tagged union or sum type for the algebraic type `RateUnit`.
export const RateUnit = __t.enum("RateUnit", {
  PerSecond: __t.unit(),
  PerMinute: __t.unit(),
  PerHour: __t.unit(),
});
export type RateUnit = __Infer<typeof RateUnit>;

export const RestApiSpec = __t.object("RestApiSpec", {
  specId: __t.u64(),
  name: __t.string(),
  specJson: __t.string(),
  createdAt: __t.timestamp(),
  createdBy: __t.string(),
});
export type RestApiSpec = __Infer<typeof RestApiSpec>;

// The tagged union or sum type for the algebraic type `RestAuthType`.
export const RestAuthType = __t.enum("RestAuthType", {
  None: __t.unit(),
  BearerToken: __t.unit(),
  BasicAuth: __t.unit(),
  ApiKeyHeader: __t.unit(),
  ApiKeyQuery: __t.unit(),
});
export type RestAuthType = __Infer<typeof RestAuthType>;

export const RestCredential = __t.object("RestCredential", {
  endpointId: __t.u64(),
  credentialJson: __t.string(),
});
export type RestCredential = __Infer<typeof RestCredential>;

export const RestEndpoint = __t.object("RestEndpoint", {
  endpointId: __t.u64(),
  name: __t.string(),
  description: __t.string(),
  url: __t.string(),
  get method() {
    return HttpMethod;
  },
  headersJson: __t.string(),
  queryParamsJson: __t.string(),
  pathParamsJson: __t.string(),
  bodyTemplate: __t.string(),
  get authType() {
    return RestAuthType;
  },
  enabled: __t.bool(),
  createdAt: __t.timestamp(),
  createdBy: __t.string(),
  updatedAt: __t.timestamp(),
  specId: __t.option(__t.u64()),
});
export type RestEndpoint = __Infer<typeof RestEndpoint>;

export const RestPollLog = __t.object("RestPollLog", {
  pollingId: __t.u64(),
  endpointId: __t.u64(),
  level: __t.string(),
  message: __t.string(),
  statusCode: __t.u32(),
  createdAt: __t.timestamp(),
});
export type RestPollLog = __Infer<typeof RestPollLog>;

export const RestPollLogGcSchedule = __t.object("RestPollLogGcSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type RestPollLogGcSchedule = __Infer<typeof RestPollLogGcSchedule>;

export const RestPollSchedule = __t.object("RestPollSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  pollingId: __t.u64(),
  endpointId: __t.u64(),
});
export type RestPollSchedule = __Infer<typeof RestPollSchedule>;

export const RestPolling = __t.object("RestPolling", {
  pollingId: __t.u64(),
  endpointId: __t.u64(),
  get status() {
    return PollingStatus;
  },
  intervalMs: __t.u64(),
  maxPolls: __t.u64(),
  totalPolls: __t.u64(),
  totalErrors: __t.u64(),
  consecutiveErrors: __t.u64(),
  lastStatusCode: __t.u32(),
  lastError: __t.string(),
  lastErrorAt: __t.option(__t.timestamp()),
  lastPollAt: __t.option(__t.timestamp()),
  startedAt: __t.timestamp(),
});
export type RestPolling = __Infer<typeof RestPolling>;

export const RestResponseMapping = __t.object("RestResponseMapping", {
  mappingId: __t.u64(),
  endpointId: __t.u64(),
  jsonPath: __t.string(),
  targetStreamName: __t.string(),
  targetTwinId: __t.string(),
  get valueType() {
    return TelemetryValueType;
  },
  eventTimeJsonPath: __t.string(),
  eventTimeFormat: __t.string(),
  description: __t.string(),
  enabled: __t.bool(),
  targetComponent: __t.string(),
  detectedType: __t.string(),
  scaleFactor: __t.f64(),
  lastEventTimeMicros: __t.i64(),
});
export type RestResponseMapping = __Infer<typeof RestResponseMapping>;

export const ScaledDecimalValue = __t.object("ScaledDecimalValue", {
  value: __t.string(),
  scale: __t.i32(),
});
export type ScaledDecimalValue = __Infer<typeof ScaledDecimalValue>;

// The tagged union or sum type for the algebraic type `SequenceOpSpec`.
export const SequenceOpSpec = __t.enum("SequenceOpSpec", {
  Ewma: __t.f64(),
  get Cusum() {
    return CusumParams;
  },
  RateOfChangePerWindow: __t.unit(),
});
export type SequenceOpSpec = __Infer<typeof SequenceOpSpec>;

export const ShortUpdate = __t.object("ShortUpdate", {
  streamName: __t.string(),
  value: __t.i16(),
});
export type ShortUpdate = __Infer<typeof ShortUpdate>;

export const StringBooleanPair = __t.object("StringBooleanPair", {
  key: __t.string(),
  value: __t.bool(),
});
export type StringBooleanPair = __Infer<typeof StringBooleanPair>;

export const StringBytePair = __t.object("StringBytePair", {
  key: __t.string(),
  value: __t.i8(),
});
export type StringBytePair = __Infer<typeof StringBytePair>;

export const StringBytesPair = __t.object("StringBytesPair", {
  key: __t.string(),
  value: __t.byteArray(),
});
export type StringBytesPair = __Infer<typeof StringBytesPair>;

export const StringDatePair = __t.object("StringDatePair", {
  key: __t.string(),
  value: __t.timestamp(),
});
export type StringDatePair = __Infer<typeof StringDatePair>;

export const StringDateTimePair = __t.object("StringDateTimePair", {
  key: __t.string(),
  value: __t.timestamp(),
});
export type StringDateTimePair = __Infer<typeof StringDateTimePair>;

export const StringDecimalPair = __t.object("StringDecimalPair", {
  key: __t.string(),
  value: __t.string(),
});
export type StringDecimalPair = __Infer<typeof StringDecimalPair>;

export const StringDoublePair = __t.object("StringDoublePair", {
  key: __t.string(),
  value: __t.f64(),
});
export type StringDoublePair = __Infer<typeof StringDoublePair>;

export const StringDurationPair = __t.object("StringDurationPair", {
  key: __t.string(),
  value: __t.timeDuration(),
});
export type StringDurationPair = __Infer<typeof StringDurationPair>;

export const StringFloatPair = __t.object("StringFloatPair", {
  key: __t.string(),
  value: __t.f32(),
});
export type StringFloatPair = __Infer<typeof StringFloatPair>;

export const StringIntegerPair = __t.object("StringIntegerPair", {
  key: __t.string(),
  value: __t.i32(),
});
export type StringIntegerPair = __Infer<typeof StringIntegerPair>;

export const StringLongPair = __t.object("StringLongPair", {
  key: __t.string(),
  value: __t.i64(),
});
export type StringLongPair = __Infer<typeof StringLongPair>;

export const StringShortPair = __t.object("StringShortPair", {
  key: __t.string(),
  value: __t.i16(),
});
export type StringShortPair = __Infer<typeof StringShortPair>;

export const StringStringPair = __t.object("StringStringPair", {
  key: __t.string(),
  value: __t.string(),
});
export type StringStringPair = __Infer<typeof StringStringPair>;

export const StringTimePair = __t.object("StringTimePair", {
  key: __t.string(),
  value: __t.timestamp(),
});
export type StringTimePair = __Infer<typeof StringTimePair>;

export const StringUnsignedBytePair = __t.object("StringUnsignedBytePair", {
  key: __t.string(),
  value: __t.u8(),
});
export type StringUnsignedBytePair = __Infer<typeof StringUnsignedBytePair>;

export const StringUnsignedIntegerPair = __t.object("StringUnsignedIntegerPair", {
  key: __t.string(),
  value: __t.u32(),
});
export type StringUnsignedIntegerPair = __Infer<typeof StringUnsignedIntegerPair>;

export const StringUnsignedLongPair = __t.object("StringUnsignedLongPair", {
  key: __t.string(),
  value: __t.u64(),
});
export type StringUnsignedLongPair = __Infer<typeof StringUnsignedLongPair>;

export const StringUnsignedShortPair = __t.object("StringUnsignedShortPair", {
  key: __t.string(),
  value: __t.u16(),
});
export type StringUnsignedShortPair = __Infer<typeof StringUnsignedShortPair>;

export const StringUpdate = __t.object("StringUpdate", {
  streamName: __t.string(),
  value: __t.string(),
});
export type StringUpdate = __Infer<typeof StringUpdate>;

export const StringUuidPair = __t.object("StringUuidPair", {
  key: __t.string(),
  value: __t.string(),
});
export type StringUuidPair = __Infer<typeof StringUuidPair>;

// The tagged union or sum type for the algebraic type `TelemetryStreamType`.
export const TelemetryStreamType = __t.enum("TelemetryStreamType", {
  Bool: __t.unit(),
  String: __t.unit(),
  Byte: __t.unit(),
  Short: __t.unit(),
  Integer: __t.unit(),
  Long: __t.unit(),
  UnsignedByte: __t.unit(),
  UnsignedShort: __t.unit(),
  UnsignedInteger: __t.unit(),
  UnsignedLong: __t.unit(),
  Float: __t.unit(),
  Double: __t.unit(),
  Decimal: __t.unit(),
  Bytes: __t.unit(),
  Date: __t.unit(),
  DateTime: __t.unit(),
  Time: __t.unit(),
  Duration: __t.unit(),
  Uuid: __t.unit(),
  Complex: __t.unit(),
  Location: __t.unit(),
});
export type TelemetryStreamType = __Infer<typeof TelemetryStreamType>;

// The tagged union or sum type for the algebraic type `TelemetryUpdate`.
export const TelemetryUpdate = __t.enum("TelemetryUpdate", {
  get Double() {
    return DoubleUpdate;
  },
  get Float() {
    return FloatUpdate;
  },
  get String() {
    return StringUpdate;
  },
  get Transform() {
    return TransformUpdate;
  },
  get Location() {
    return LocationUpdate;
  },
  get Bool() {
    return BoolUpdate;
  },
  get Decimal() {
    return DecimalUpdate;
  },
  get Byte() {
    return ByteUpdate;
  },
  get Short() {
    return ShortUpdate;
  },
  get Integer() {
    return IntegerUpdate;
  },
  get Long() {
    return LongUpdate;
  },
  get UnsignedByte() {
    return UnsignedByteUpdate;
  },
  get UnsignedShort() {
    return UnsignedShortUpdate;
  },
  get UnsignedInteger() {
    return UnsignedIntegerUpdate;
  },
  get UnsignedLong() {
    return UnsignedLongUpdate;
  },
});
export type TelemetryUpdate = __Infer<typeof TelemetryUpdate>;

// The tagged union or sum type for the algebraic type `TelemetryValue`.
export const TelemetryValue = __t.enum("TelemetryValue", {
  Bool: __t.bool(),
  String: __t.string(),
  Byte: __t.i8(),
  Short: __t.i16(),
  Integer: __t.i32(),
  Long: __t.i64(),
  UnsignedByte: __t.u8(),
  UnsignedShort: __t.u16(),
  UnsignedInteger: __t.u32(),
  UnsignedLong: __t.u64(),
  Float: __t.f32(),
  Double: __t.f64(),
  Decimal: __t.string(),
  Bytes: __t.byteArray(),
  Date: __t.timestamp(),
  DateTime: __t.timestamp(),
  Time: __t.timestamp(),
  Duration: __t.timeDuration(),
  Uuid: __t.string(),
});
export type TelemetryValue = __Infer<typeof TelemetryValue>;

// The tagged union or sum type for the algebraic type `TelemetryValueType`.
export const TelemetryValueType = __t.enum("TelemetryValueType", {
  Double: __t.unit(),
  Float: __t.unit(),
  Integer: __t.unit(),
  Long: __t.unit(),
  Bool: __t.unit(),
  String: __t.unit(),
  Location: __t.unit(),
  Array: __t.unit(),
});
export type TelemetryValueType = __Infer<typeof TelemetryValueType>;

export const TelemetryWindowPoint = __t.object("TelemetryWindowPoint", {
  effectiveMicros: __t.i64(),
  streamId: __t.u64(),
  streamName: __t.string(),
  eventTime: __t.timestamp(),
  get value() {
    return TelemetryValue;
  },
});
export type TelemetryWindowPoint = __Infer<typeof TelemetryWindowPoint>;

export const TransformUpdate = __t.object("TransformUpdate", {
  streamName: __t.string(),
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
  yaw: __t.f32(),
  pitch: __t.f32(),
  roll: __t.f32(),
});
export type TransformUpdate = __Infer<typeof TransformUpdate>;

export const TransformWindowPoint = __t.object("TransformWindowPoint", {
  effectiveMicros: __t.i64(),
  streamId: __t.u64(),
  streamName: __t.string(),
  eventTime: __t.timestamp(),
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
  yaw: __t.f32(),
  pitch: __t.f32(),
  roll: __t.f32(),
});
export type TransformWindowPoint = __Infer<typeof TransformWindowPoint>;

export const TwinTransform = __t.object("TwinTransform", {
  streamId: __t.u64(),
  streamName: __t.string(),
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
  yaw: __t.f32(),
  pitch: __t.f32(),
  roll: __t.f32(),
  eventTime: __t.timestamp(),
  description: __t.string(),
});
export type TwinTransform = __Infer<typeof TwinTransform>;

export const UnsignedByteUpdate = __t.object("UnsignedByteUpdate", {
  streamName: __t.string(),
  value: __t.u8(),
});
export type UnsignedByteUpdate = __Infer<typeof UnsignedByteUpdate>;

export const UnsignedIntegerUpdate = __t.object("UnsignedIntegerUpdate", {
  streamName: __t.string(),
  value: __t.u32(),
});
export type UnsignedIntegerUpdate = __Infer<typeof UnsignedIntegerUpdate>;

export const UnsignedLongUpdate = __t.object("UnsignedLongUpdate", {
  streamName: __t.string(),
  value: __t.u64(),
});
export type UnsignedLongUpdate = __Infer<typeof UnsignedLongUpdate>;

export const UnsignedShortUpdate = __t.object("UnsignedShortUpdate", {
  streamName: __t.string(),
  value: __t.u16(),
});
export type UnsignedShortUpdate = __Infer<typeof UnsignedShortUpdate>;

// The tagged union or sum type for the algebraic type `WindowSize`.
export const WindowSize = __t.enum("WindowSize", {
  Min1: __t.unit(),
  Min5: __t.unit(),
  Min15: __t.unit(),
  Hour1: __t.unit(),
  Shift8H: __t.unit(),
  Day1: __t.unit(),
});
export type WindowSize = __Infer<typeof WindowSize>;

// The tagged union or sum type for the algebraic type `WindowTimebase`.
export const WindowTimebase = __t.enum("WindowTimebase", {
  System: __t.unit(),
  Event: __t.unit(),
});
export type WindowTimebase = __Infer<typeof WindowTimebase>;

export const SpacetimedbReplayGrant = __t.object("SpacetimedbReplayGrant", {
  table: __t.string(),
  tsMinMicros: __t.i64(),
  tsMaxMicros: __t.i64(),
});
export type SpacetimedbReplayGrant = __Infer<typeof SpacetimedbReplayGrant>;

